import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ReactComponent as LocationIcon } from "../assets/location-share.svg";
import Button from "../components/Button";
import { useLocationFetching } from "../hooks";
import { ROUTES } from "..";
import { useRecoEngine } from "../context/RecoEngineContext";
import { handleRedirect } from "../../../utils/CommonFunctions";
import { ShowBottomBar } from "../../../services/ToggleNativeBar";

interface LocationPageProps {
  onNavigateStart?: () => void;
}

const LocationPage = ({ onNavigateStart }: LocationPageProps) => {
  const [t] = useTranslation("translations");
  const query = localStorage.getItem("query") || "";
  const queryObject = JSON.parse(localStorage.getItem("queryObject") || "{}");
  const navigate = useNavigate();
  const { locationData, setLocationData } = useRecoEngine();
  const [locationReady, setLocationReady] = useState(false);
  const { fetchLocationWithGeocoding } = useLocationFetching();
  
  useEffect(() => {
    ShowBottomBar(false);
  }, []);


  useEffect(() => {
    if (locationReady && locationData.latitude && queryObject.latitude) {
        onNavigateStart?.();
        handleRedirect(
          {
            type: "IN_APP_BROWSER", 
            url: `${window.location.origin}${ROUTES.RecoPage.path}`,
            hideToolBar: true,
            traverseWebHistoryOnBackPressed: false
          },
          navigate,
          "Regional Service Assistant",
          "RECO_ENGINE",
          { 
            query: query,
            fsa: locationData.fsa,
            latitude: locationData.latitude, 
            longitude: locationData.longitude,
            radius: locationData.radius
          }
        );
    }
  }, [locationReady, locationData, queryObject, onNavigateStart]);

  const handleGetLocation = async () => {
    fetchLocationWithGeocoding(
      (locationWithFSA) => {
        setLocationData(locationWithFSA);
        localStorage.setItem("location", JSON.stringify(locationWithFSA));
        localStorage.setItem("queryObject", JSON.stringify({ 
          ...queryObject, 
          latitude: locationWithFSA.latitude, 
          longitude: locationWithFSA.longitude, 
          radius: locationWithFSA.radius,
          fsa: locationWithFSA.fsa,
          query 
        }));
        setLocationReady(true);
      },
      (err) => {
        setLocationData(err);
        localStorage.setItem("location", JSON.stringify(err));
        localStorage.setItem("queryObject", JSON.stringify({ 
          ...queryObject, 
          latitude: err.latitude, 
          longitude: err.longitude, 
          radius: err.radius,
          fsa: err.fsa,
          query 
        }));
        setLocationReady(true);
        console.error(`Unable to get your location: ${err.message}`);
      }
    );
  };

  const handleNoLocationNavigation = () => {
    localStorage.setItem("queryObject", JSON.stringify({ 
      ...queryObject,
      query: query,
      longitude: window.config?.default_location?.longitude || -79.45306,
      latitude: window.config?.default_location?.latitude || 44.06056,
      radius: window.config?.default_location?.radius || 10,
      fsa: "L3Y"
    }));
    onNavigateStart?.();
    handleRedirect(
      {
        type: "IN_APP_BROWSER", 
        url: `${window.location.origin}${ROUTES.RecoPage.path}`,
        hideToolBar: true,
        traverseWebHistoryOnBackPressed: false
      },
      navigate,
      "Regional Service Assistant",
      "RECO_ENGINE",
      { 
        query: query,
        fsa: "L3Y",
        longitude: window.config?.default_location?.longitude || -79.45306,
        latitude: window.config?.default_location?.latitude || 44.06056,
        radius: window.config?.default_location?.radius || 10
      }
    );
  };

  return (
    <div className="location__page">
      <LocationIcon />
      <h3>{t("RecoSearch.location_on")}</h3>
      <p>{t("RecoSearch.location_on_desc1")}</p>
      <p>{t("RecoSearch.location_on_desc2")}</p>
      <Button text={t("RecoSearch.share_location")} onClick={() => handleGetLocation()} />
      <Button
        className="text-only"
        text={t("RecoSearch.remind_me")}
        onClick={() => handleNoLocationNavigation()}
      />
      <p className="disclaimer">{t("RecoSearch.location_saved")}</p>
    </div>
  );
};

LocationPage.displayName = "LocationPage";

export default LocationPage;
